import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { FilterChipGroup } from './FilterChipGroup';
import { EMISSOR_ORDER_FILTER_STATUS_LABELS, EMISSOR_ORDER_FILTER_STATUS_ORDER } from './types';
export function EmissorOrderStatusFilter({ value, onChange, testIdPrefix }) {
    const { t } = useTranslation();
    const options = useMemo(() => EMISSOR_ORDER_FILTER_STATUS_ORDER.map(status => ({
        id: status,
        label: t(EMISSOR_ORDER_FILTER_STATUS_LABELS[status]),
    })), [t]);
    return (_jsx(FilterChipGroup, { label: t('benefits.orders.filter.status'), options: options, selectedIds: value, onChange: selectedIds => onChange(selectedIds), testIdPrefix: testIdPrefix }));
}
